import axios from 'axios';

import clientConfig from '../client-config';

export async function getDBVersion() {
  let res;
  try {
    res = await axios.get(clientConfig.backendHOST + '/admin/Version');
  } catch (e) {
    console.error(e);
  }
  if (res) {
    if (res.status === 200) {
      return {
        isOk: true,
        data: res.data,
      };
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}
